"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import toast from "react-hot-toast";
import { LogIn, Key, Shield, User, HeartPulse, ArrowRight, RefreshCw } from "lucide-react";

export default function LoginPage() {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ username: "", password: "" });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (!res.ok) {
        toast.error(data.error || "بيانات الدخول غير صحيحة");
        return;
      }

      toast.success(`مرحباً ${data.user.name}!`);
      await router.push("/dashboard");
    } catch {
      toast.error("حدث خطأ في الاتصال. حاول مرة أخرى.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card" style={{ 
        maxWidth: 420, 
        width: "90%", 
        padding: 48,
        background: "rgba(17, 24, 39, 0.8)",
        backdropFilter: "blur(20px)",
        border: "1px solid var(--bg-border)",
        boxShadow: "var(--shadow-lg)"
      }}>
        {/* Logo */}
        <div className="text-center" style={{ marginBottom: 40, textAlign: "center" }}>
          <div
            style={{
              width: 88,
              height: 88,
              background: "linear-gradient(135deg, rgba(124, 58, 237, 0.2), rgba(61, 1, 119, 0.4))",
              border: "1px solid rgba(139, 92, 246, 0.3)",
              borderRadius: 24,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              boxShadow: "0 12px 36px rgba(61, 1, 119, 0.5)",
              padding: 10,
            }}
          >
            <img src="/plexa-icon.png" alt="Plexa" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          </div>
          <h1
            style={{
              fontSize: 32,
              fontWeight: 900,
              color: "var(--text-primary)",
              marginBottom: 8,
              letterSpacing: "-1px"
            }}
          >
            بليكسا | Plexa
          </h1>
          <p style={{ color: "var(--text-muted)", fontSize: 15 }}>
            الوصول الآمن للوحة التحكم
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 24 }}>
          <div className="form-group">
            <label className="form-label" style={{ fontWeight: 700, fontSize: 13, marginBottom: 8, display: "block" }}>اسم المستخدم</label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                className="form-input"
                placeholder="اسم المستخدم"
                value={form.username}
                onChange={(e) => setForm((f) => ({ ...f, username: e.target.value }))}
                required
                style={{ paddingRight: 40, height: 50, borderRadius: 12 }}
              />
              <User size={18} style={{ position: "absolute", right: 14, top: 16, color: "var(--text-muted)" }} />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label" style={{ fontWeight: 700, fontSize: 13, marginBottom: 8, display: "block" }}>كلمة المرور</label>
            <div style={{ position: "relative" }}>
              <input
                type="password"
                className="form-input"
                placeholder="••••••••"
                value={form.password}
                onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
                required
                style={{ paddingRight: 40, height: 50, borderRadius: 12 }}
              />
              <Key size={18} style={{ position: "absolute", right: 14, top: 16, color: "var(--text-muted)" }} />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ 
              height: 52, 
              borderRadius: 12, 
              fontSize: 16, 
              fontWeight: 800,
              marginTop: 8,
              boxShadow: "0 10px 24px rgba(124, 58, 237, 0.35)"
            }}
          >
            {loading ? (
              <RefreshCw className="animate-spin" size={20} />
            ) : (
              <div className="flex items-center gap-2">
                <span>دخول للنظام</span>
                <ArrowRight size={20} />
              </div>
            )}
          </button>
        </form>

        <div style={{ marginTop: 40, paddingTop: 32, borderTop: "1px solid var(--bg-border)", textAlign: "center" }}>
          <p style={{ fontSize: 12, color: "var(--text-muted)", opacity: 0.8 }}>
            بليكسا © {new Date().getFullYear()} — جميع الحقوق محفوظة
          </p>
        </div>
      </div>
    </div>
  );
}
